<template>
  <b-row>
    <b-col v-if="connectionStateComponent">
      <component
        :is="connectionStateComponent"
        :error-code="errCode"
        :error-text="errText"
      />
    </b-col>
    <b-col v-else>
      <loading-spinner v-if="loading">
        <div slot="title">
          Requesting Square Authorization
        </div>
        Please wait while processing connection request.
      </loading-spinner>
    </b-col>
  </b-row>
</template>

<script>
import SquarePaymentsOAuth2ConnectFailure from './SquarePaymentsOAuth2ConnectFailure.vue'
import SquarePaymentsOAuth2ConnectSuccess from './SquarePaymentsOAuth2ConnectSuccess.vue'

export default {
  name: 'square-payments-oauth2-redirect',
  components: {
    'square-payments-oauth2-connect-success': SquarePaymentsOAuth2ConnectSuccess,
    'square-payments-oauth2-connect-failure': SquarePaymentsOAuth2ConnectFailure
  },
  props: {
    redirect: {
      type: String,
      required: false,
      default: () => false
    },
    timeout: {
      type: Number,
      required: false,
      default: 1000
    }
  },
  data: function() {
    return {
      loading: false,
      connectionStateComponent: null,
      errCode: '',
      errText: ''
    }
  },
  created: function() {
    this.loading = true
    setTimeout(_ => {
      this.loading = false
      const urlParams = new URLSearchParams(location.search)
      // Check that the State that was returned matches the state that we initiall sent to the microservice
      try {
        const state = urlParams.get('state')
        const expState = this.$store.getters['square/oAuth2State']()
        if (state !== expState) {
          throw new Error(`Mismatech OAuth2 Connection State: ${state} -- ${expState}`)
        }
        // Check that the connection state did not take too long to be connected.
        this.errCode = urlParams.get('error')
        this.errText = urlParams.get('errorText')
        if (this.errCode) {
          this.connectionStateComponent = SquarePaymentsOAuth2ConnectFailure
        }
        else {
          this.connectionStateComponent = SquarePaymentsOAuth2ConnectSuccess
          if (this.redirect) {
            setTimeout(() => {
              this.$router.push(this.redirect)
            }, this.timeout)
          }
        }
      }
      catch (err) {
        this.errCode = '0000'
        this.errText = err.message
        this.connectionStateComponent = SquarePaymentsOAuth2ConnectFailure
        console.error(err.message)
      }
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
